import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import InviteTeammateSplash from '~/Common-Objects/Onboarding/splashes/invite-teammate.png'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function UsersStep({
    isOpen,
    isComplete,
    onClick,
    onInvite,
    onSkip,
    canSkip,
    postHogTag,
    postHogTagSkip
}) {
    return (
        <OnboardingStep
            key='users'
            title={i18n.t('setup:steps.invite-teammate.title')}
            icon={<Icons icon='personAddOutline' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.invite-teammate.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onInvite()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.invite-teammate.button-text')}
                </Button>
                {canSkip && (
                    <Button
                        className='button-ghost button-small'
                        onClick={(e) => {
                            e.stopPropagation()
                            onSkip()
                        }}
                        data-ph={postHogTagSkip}
                    >
                        {i18n.t('setup:steps.invite-teammate.skip-text')}
                    </Button>
                )}
            </div>
        </OnboardingStep>
    )
}

UsersStep.splash = <img src={InviteTeammateSplash} alt={i18n.t('setup:steps.invite-teammate.title')} />
